import { routes } from '../../containers/routes/routes-names';
import { useNavigate } from 'react-router-dom';
import { SignupTabs } from './SignupLayout';
import { useRegistration } from './RegistrationContext';
import { history } from '../../history';
import { localStorageRemoveItem } from '../storage/localStorageManager';
import { USER_DATA_CACHE_KEY } from '../../config/constants';
import secureLocalStorage from 'react-secure-storage';

type SignUpBackBtnProp = {
    activeTab: string;
    showPasswordTab: boolean;
    candidateType: string;
    setShowPasswordTab: (key: boolean) => void;
    setActiveTab: (tab: string) => void;
    unclaimedData?: any;
    ConfirmUnclaimedCandidateInvitationId?: any;
    resetAllState: () => void;
};

const SignUpBackButton: React.FC<SignUpBackBtnProp> = ({
    activeTab,
    setActiveTab,
    candidateType,
    showPasswordTab,
    setShowPasswordTab,
    ConfirmUnclaimedCandidateInvitationId,
    unclaimedData,
    resetAllState,
}) => {
    const navigate = useNavigate();

    return (
        <div>
            <div className="row">
                <div className="col-md-12 my-3">
                    <span
                        className="text-secondary cursor-pointer"
                        onClick={() => {
                            if (activeTab === SignupTabs.ACCOUNT_TYPE) {
                                if (unclaimedData && unclaimedData?.claimedType === 'company') {
                                    history.go(-1);
                                    resetAllState();
                                } else {
                                    navigate(routes.main);
                                    resetAllState();
                                }
                            } else if (activeTab === SignupTabs.AUTH_TYPE) {
                                if (unclaimedData && unclaimedData?.claimedType === 'company') {
                                    history.go(-1);
                                } else {
                                    setActiveTab(SignupTabs.ACCOUNT_TYPE);
                                }
                            } else if (activeTab === SignupTabs.BASIC_DETAILS) {
                                if (ConfirmUnclaimedCandidateInvitationId) {
                                    navigate(routes.main);
                                } else {
                                    if (candidateType === 'company' && showPasswordTab) {
                                        setShowPasswordTab(false);
                                    } else {
                                        setActiveTab(SignupTabs.AUTH_TYPE);
                                    }
                                }
                            } else if (activeTab === SignupTabs.SIGNUP_FORM) {
                                localStorageRemoveItem('selectedDate');
                                secureLocalStorage.removeItem(USER_DATA_CACHE_KEY);
                                if (candidateType === 'company') {
                                    setActiveTab(SignupTabs.BASIC_DETAILS);
                                    setTimeout(() => {
                                        setShowPasswordTab(true);
                                    }, 0);
                                } else {
                                    setActiveTab(SignupTabs.BASIC_DETAILS);
                                }
                            } else {
                                navigate(routes.main);
                            }
                        }}
                    >
                        <i className="bi bi-chevron-left lt-text-secondary-alt me-0"></i> Back
                    </span>
                </div>
            </div>
        </div>
    );
};

export default SignUpBackButton;
